import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MotionWrapper from '../../component/MotionWrapper';
import axios from 'axios';
import Letter from '../../component/Spring/Letter';
import Dday_Spring from '../../component/Spring/Dday_Spring';
import Message_Spring from '../../component/Spring/Message_Spring';
import Location_Spring from '../../component/Spring/Location_Spring';
import Footer from '../../component/Footer';
import Loading from '../../component/Loading';
import Location_Desc from '../../component/Location/Location_Desc';
import Music from '../../component/Music';
import AccountList from '../../component/Account/AccountList';
import Sharing from '../../component/Sharing';
import GalleryList from '../../component/Gallery/GalleryList';
import Main_Summer from '../../component/Summer/Main_Summer';
import Save_Date from '../../component/Save_Date';
import Info_Spring from '../../component/Spring/Info_Spring';
import Interview_Spring from '../../component/Spring/Interview_Spring';
import CallInfo from '../../component/CallInfo';
import Information from '../../component/Information';
import Info_Spring2 from '../../component/Spring/Info_Spring2';
import musicTitle from '../../asset/music/damin.mp3'


const KimDoYeong = () => {
    const navigate = useNavigate(); 
    const { mainPage } = useParams();

    const API_URL = process.env.REACT_APP_API_URL;

    const [loading, setLoading] = useState(true);
    const [fontsLoaded, setFontsLoaded] = useState(false);

    const openTitle = "김경태♥김도영 결혼합니다.";
    const openDesc = "7월 13일 오전 11시 30분";
    const openThumb = "https://d39wt6wnedokd1.cloudfront.net/228/thumb1.jpg";

    const lng = 126.8857411;
    const lat = 37.5060786;

    const placeTelNum = "02-2162-2100";
    
    const forParking = "P1 리베라컨벤션 / P2 리베라야외주차장 \nP3 공영주차타워주차장 / P4 엠포리움주차장 \nP5 범한빌딩주차장 / P6 국민은행주차장\nP7 미성주차장 / P8 수협주차장 / P9 STX주차장\n\n본관건물 2시간 무료, 외부지정주차장 1시간 무료";
    const forCar = "주소: 서울특별시 구로구 경인로 624/ T : 02-2162-2100\n라마다 서울 신도림 호텔 내 주차장 (90분 무료)"
    const forSubway = "1• 2호선 신도림역 1,5번출구 → 도보 약 7분\n(1번 출구 앞 셔틀버스)"
    const forBus = "신도림동(구로역) 정류장 하차 → 도보 약 5분 \n(간선: 160, 503, 600,660/ 지선: 6515, 6637 외) \n\n신도림중학교 정류장 하차 → 도보 약 7분 \n(지선: 5615, 6512 외)"

    const [weddingData, setWeddingData] = useState({
        id:'',
        concept: '',
        weddingDate: '',
        invitationInfoId: '',
        brideName: '',
        groomName: '',
        brideNameEn: '',
        groomNameEn: '',
        year:'',
        month:'',
        date:'',
        dayOfWeek:'',
        time:'',
        place:'',
        address:'',
        mainImg:'',
        subImg:'',
        pointColor: '',
        btnFontColor: '',
        btnBgColor: '',
        isGuestBookOpen: ''
    });


    const conceptStyle = {
        // summer 와인
        concept: "SUMMER",
        titleColor: "#5b0100",
        pointColor: "#5b0100",
        btnBgColor: "#5b0100",
        fontColor: "#ffffff",
        btnFontColor: "#ffffff",
        chatBgColor: "#F5F8FF",
        fontFamilyKo: "SCDream3",
        fontFamilyEn: "Edensor"
    }

    const title = "정중한 마음으로 초대합니다.";

    const msg1 = "함께 있을 때 가장 나다운 모습이 되고\n함께 있을 때 미래를 꿈꾸게 하는 사람을 만났습니다."
    const msg2 = "초록빛 싱그러운 여름, 두 사람이 하나 되어\n소중한 인연을 맺고자 합니다."
    const msg3 = "지켜봐 주셨던 소중한 분들을 모십니다.\n오셔서 따뜻한 마음으로 축복해주세요."


    const parents = [
        {groom : "❁박금주 · 이윤실의 장남"},
        {bride : "이학두 · 최경숙의 차녀"}
    ]

    const groomAccountList = [
        {
            role: "신랑",
            name: "김경태",
            bank: "하나은행",
            accountNumber : "01053029698907",
            isKakao : false
        }
        ,{
            role: "신랑 부",
            name: "김종환",
            bank: "하나은행",
            accountNumber : "580-910066-16207",
            isKakao : false
        }
        ,{
            role: "신랑 모",
            name: "조경숙",
            bank: "국민은행",
            accountNumber : "487701-04-015400",
            isKakao : false
        }
    ]

    const brideAccountList = [
        {
            role: "신부",
            name: "김도영",
            bank: "카카오뱅크",
            accountNumber : "3333-07-9854627",
            isKakao : false
        }
        ,{
            role: "신부 부",
            name: "김기열",
            bank: "농협은행",
            accountNumber : "319-02-070501",
            isKakao : false
        }
        ,{
            role: "신부 모",
            name: "김명희",
            bank: "농협은행",
            accountNumber : "319-02-013080",
            isKakao : false
        }
    ]

    const account_explain = "따로 계좌번호를 여쭤보시는 수고를 덜기 위해 기입합니다. \n부담 안가지셨으면 좋겠습니다."

    const interviewContent = [
        {
            question : "우리의 설레였던 첫 만남 기억해?",
            groomAnswer: "예뻤어",
            brideAnswer: "잘생겼더라"
        },
        {
            question : "결혼을 앞둔 소감이 어때?",
            groomAnswer: "꿈만 같아",
            brideAnswer: "설레어"
        },
        {
            question : "서로에게 하고 싶은 말은?",
            groomAnswer: "항상 고마워",
            brideAnswer: "네가 최고야"
        },
        {
            question : "유부남/녀 기념 각오 한마디!",
            groomAnswer: "평생 사랑해",
            brideAnswer: "나도 사랑해"
        },
        {
            question : "마지막으로 전하고 싶은 이야기는?",
            groomAnswer: "축복해주세요",
            brideAnswer: "잘 살게요♥️"
        },
    ]

    const groomCallInfoList = [
        {
            role: "신랑",
            name: "김경태",
            call: "010-5302-9698"
        }
        ,{
            role: "신랑 부",
            name: "김종환",
            call: "010-3129-9912"
        }
        ,{
            role: "신랑 모",
            name: "조경숙",
            call: "010-6438-9916"
        }
    ]

    const brideCallInfoList = [
        {
            role: "신부",
            name: "김도영",
            call: "010-6821-1364"
        }
        ,{
            role: "신부 부",
            name: "김기열",
            call: "010-6780-1364"
        }
        ,{
            role: "신부 모",
            name: "김명희",
            call: "010-9566-1364"
        }
    ]

    const informationList =[
        {
            title : "신부측 전세버스 안내",
            content : "장소: 영동 하상주차장\n일시: 2025년 07월 13일(일요일) 오전 7시"
        }
    ]

    const fetchInvitationInfoData = async () => {
        try {
            const response = await axios.get(`${API_URL}/_api/v1/invitation_info/${mainPage}`);
            if(response.status === 200){
                const [y, m, d] = response.data.data.weddingDate.split('-');

                setWeddingData(prevData => {
                    const newData = {
                        id: response.data.data.id,
                        concept: response.data.data.concept,
                        weddingDate: response.data.data.weddingDate,
                        invitationInfoId: response.data.data.id,
                        brideName: response.data.data.brideNameKo,
                        groomName: response.data.data.groomNameKo,
                        brideNameEn: response.data.data.brideNameEn,
                        groomNameEn: response.data.data.groomNameEn,
                        year: y,
                        month: m,
                        date: d,
                        dayOfWeek: response.data.data.dayOfWeek,
                        time: response.data.data.time,
                        place: response.data.data.place,
                        address: response.data.data.address,
                        mainImg: response.data.data.mainImg,
                        subImg: response.data.data.subImg,
                        pointColor: response.data.data.pointColor,
                        btnBgColor: response.data.data.btnBgColor,
                        btnFontColor: response.data.data.btnFontColor,
                        isGuestBookOpen: response.data.data.isGuestBookOpen
                    };
                    return newData;
                });
            } 
        } catch (error) {
            console.error("API 요청 실패:", error.response ? error.response.data : error.message);
        }
    };

    useEffect(() => {
        const fetchDataSequentially = async () => {
            if (!weddingData.weddingDate) {  
                await fetchInvitationInfoData();
            }
        };
        fetchDataSequentially();  
    
        document.body.style.overflow = 'hidden';
    
        const timer = setTimeout(() => {
            document.body.style.overflow = '';
        }, 3000);
    
        return () => {
            clearTimeout(timer);
            document.body.style.overflow = '';
        };
    }, []);

    useEffect(() => {
        const fontLoadObserver = async () => {
            await document.fonts.ready; 
            setFontsLoaded(true); 
            setLoading(false);
        };
        if(!weddingData.weddingDate){
            fontLoadObserver();
        }
    }, []);

    const goToGuestBook = () => {
        navigate(`/${mainPage}/guest`); 
    };

    // 성을 제외하고 이름만 추출 ex. 가영
    const getFirstKoName = (fullName) => {
        const nameParts = fullName.split(''); 
        return nameParts.slice(1).join(''); 
    };

    // 성을 제외하고 이름만 추출 ex.Gayeong
    const getFirstNameEn = (fullName) => {
        const nameParts = fullName.split(' '); 
        const firstName = nameParts.slice(1).join(''); 
        return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
    };

    // ex. Kim Gayeong
    const getRemoveSpaceName = (fullName) => {
        const nameParts = fullName.split(' '); // 문자열을 띄어쓰기로 분리
        const firstName = nameParts[0]; // 첫 번째 단어 유지
        const restName = nameParts.slice(1).join(''); // 나머지 단어를 소문자로 변경하고 결합
        return firstName + ' ' + restName.charAt(0).toUpperCase() + restName.slice(1).toLowerCase();
    };

        // 성을 제외하고 이름만 추출 ex.Gayeong
        const getFirstEnName = (fullName) => {
            const nameParts = fullName.split(' '); 
            const firstName = nameParts.slice(1).join(''); 
            return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
        };
        
        // 브라운 #693818
        // 와인 #5b0100
        // #761B40
        // #423866
        // #d98db9
        // #FF8A83
    return (
        <div>
            {loading || !fontsLoaded ? (
                <Loading color={"#5b0100"} loading={loading} />
            ) : (
                <>
                    <Music concept={conceptStyle.concept} musicTitle={musicTitle}/>
                    <Main_Summer weddingData={weddingData} groomNameEn={getRemoveSpaceName(weddingData.brideNameEn)} brideNameEn={getRemoveSpaceName(weddingData.groomNameEn)} color={"#ffffff"} letteringFontColor={"#ffffff"} dateColor={"#ffffff"} bottom={"27%"} bottom2={"17.5%"} dateBottom={"1%"} top={"60%"}/>
                    <Save_Date color={conceptStyle.pointColor} isBorder={true} marginTop={"100px"} marginBottom={"10px"} fontSize={"13px"} />
                    <Info_Spring2  weddingData={weddingData} conceptStyle={conceptStyle} brideNameEn={getFirstEnName(weddingData.brideNameEn)} groomNameEn={getFirstEnName(weddingData.groomNameEn)}/>
                    <Letter title={title} msg1={msg1} msg2={msg2} msg3={msg3} conceptStyle={conceptStyle} />
                    <CallInfo marginTop={"30px"} conceptStyle={conceptStyle} groomCallInfoList={groomCallInfoList} brideCallInfoList={brideCallInfoList}/>
                    <Dday_Spring isAttendFromClose={true} brideName={getFirstKoName(weddingData.brideName)} groomName={getFirstKoName(weddingData.groomName)} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    <MotionWrapper initialY={50}>
                        <GalleryList fontFamilyKo={conceptStyle.fontFamilyKo} fontFamilyEn={conceptStyle.fontFamilyEn} color={conceptStyle.titleColor} weddingData={weddingData} initCount={9} photoWidth={"110px"} photoHeight={"150px"} gap={"3px"}/>
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <AccountList conceptStyle={conceptStyle} groomAccountList={groomAccountList} brideAccountList={brideAccountList} account_explain={account_explain} />
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <Message_Spring weddingData={weddingData} goToGuestBook={goToGuestBook} weddingDate={weddingData.weddingDate} 
                            conceptStyle={conceptStyle} 
                            btnBgColor={weddingData.btnBgColor} btnFontColor={weddingData.btnFontColor} titleColor={weddingData.titleColor}
                            />
                    </MotionWrapper>
                    <MotionWrapper initialY={50}>
                        <Interview_Spring interviewContent={interviewContent} weddingData={weddingData} conceptStyle={conceptStyle} />
                    <Information height={"100px"} divHeight={"180px"} conceptStyle={conceptStyle} informationList={informationList} />
                        <Location_Spring weddingData={weddingData} conceptStyle={conceptStyle} lng={lng} lat={lat} placeTelNum={placeTelNum}/>
                    </MotionWrapper>
                    <Location_Desc isPoint={true} forParking={forParking} forCar={forCar} forSubway={forSubway} forBus={forBus} conceptStyle={conceptStyle}/>
                    <Sharing conceptStyle={conceptStyle} title={openTitle} description={openDesc} thumbImg={openThumb}/>
                    <Footer />
                </>
            )}
        </div>
    );
    
};

export default KimDoYeong;